import { Permission } from "./permission.model";

export class Role {
    id?: string;
    name?: string;
    organization_id?: string;
    intune_group?: { id: string, displayName: string };
    is_read_only?: boolean;

    created_at?: string;
    updated_at?: string;

    users_count?: number;

    permissions_count?: number;
    permissions?: Permission[];

    constructor(init?: Partial<Role>) {
        Object.assign(this, init);
    }
}